export default "__VITE_ASSET__6682ab1a__"